import { render, staticRenderFns } from "./HeadToHead.vue?vue&type=template&id=762c876a&scoped=true&"
import script from "./HeadToHead.vue?vue&type=script&lang=js&"
export * from "./HeadToHead.vue?vue&type=script&lang=js&"
import style0 from "./HeadToHead.vue?vue&type=style&index=0&id=762c876a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762c876a",
  null
  
)

export default component.exports